import { __ } from "@wordpress/i18n";

import "./style.scss";

const BControlPro = ({ label, className, onChange, onSelect, media = false, isPremium = false, Component, setOpen = () => {}, ...restProps }) => {
  const labelMiddleWare = (label) => {
    return isPremium ? (
      label
    ) : (
      <>
        <span className="bplOpacity75">{label}</span> <span className="labelPro">Pro</span>
      </>
    );
  };

  return (
    <Component
      className={`${className} ${isPremium ? "" : "bplProIdentifier"}`}
      label={labelMiddleWare(label)}
      onChange={(val) => (isPremium ? (media ? onSelect(val) : onChange(val)) : setOpen(true))}
      onSelect={(val) => (isPremium ? onSelect(val) : setOpen(true))}
      isPremium={isPremium}
      {...restProps}
    />
  );
};

export default BControlPro;
